import { isInputHasLocale } from "helpers/forms";
import React from "react";
import { FormattedMessage } from "react-intl";

const InputTitle = ({ name, locale }) => {
  if (!name?.length > 0) return "";
  return (
    <span>
      <FormattedMessage
        id={name}
        values={{ locale: <FormattedMessage id={locale} /> }}
      />
      {isInputHasLocale(locale) ? (
        <>
          {" "}
          (<FormattedMessage id={`${locale}-language`} />){" "}
        </>
      ) : (
        ""
      )}
    </span>
  );
};

export default InputTitle;
